import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;

  const isSpecialPage = ['/privacy', '/terms', '/faq', '/about'].includes(currentPath);

  return (
    <div className="section is--nav w-nav" role="banner" data-collapse="medium" data-animation="default" data-duration="400" data-no-scroll="1" data-easing="ease" data-easing2="ease">
      <div className="container-2 is--nav">
        <Link to="/" className="logo w-inline-block ">
          <div className="logo-text">
            <img src="img/eworxs.png" alt="EWORXS logo" className="logo" />
          </div>
        </Link>

        <div className="nav-menu">
          <Link to="/selfemployed" style={{ display: 'none' }} className={`nav-link w-inline-block ${currentPath === '/' ? 'w--current' : ''}`} title="Self Employed">
            <div className="nav-link_text">Self Employed</div>
          </Link>
          <Link to="/teams" className={`nav-link w-inline-block ${currentPath === '/teams' ? 'w--current' : ''}`} title="Teams">
            <div className="nav-link_text">Teams</div>
          </Link>
          <Link to="/pricing" className={`nav-link w-inline-block ${currentPath === '/pricing' ? 'w--current' : ''}`} title="Pricing">
            <div className="nav-link_text">Pricing</div>
          </Link>
          <Link to="/faq" className={`nav-link w-inline-block ${currentPath === '/faq' ? 'w--current' : ''}`} title="FAQ">
            <div className="nav-link_text">FAQ</div>
          </Link>
        </div>

        <button 
          className={`menu-icon-wrapper is--hamburger-open w-inline-block ${isMenuOpen ? 'is-open' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <div className="close-overlay is--hamburger-close"></div>
          <div className="menu-line is--upper"></div>
          <div className="menu-line is--middle"></div>
          <div className="menu-line is--lower"></div>
        </button>

        <div className="nav-buttons">
          <a href={`${process.env.REACT_APP_ADMIN_URL}/login`} className="nav-button is--indigo-extra-light w-inline-block">
            <div>Sign In</div>
          </a>
          {isSpecialPage ? (
            <Link to="/#pricing" className="nav-button is--indigo w-inline-block">
              <div>Sign Up</div>
            </Link>
          ) : (
            <a href="#pricing" className="nav-button is--indigo w-inline-block">
              <div>Sign Up</div>
            </a>
          )}
        </div>
      </div>

      <div className={`overlay-menu ${isMenuOpen ? 'is--open' : ''}`}>
        <div className="overlay-links">
          {/* <Link to="/selfemployed" className="overlay-menu-link is--hamburger-close w-inline-block w--current" title="Self Employed">
            <div>Self Employed</div>
          </Link> */}
          <Link to="/teams" className={`overlay-menu-link is--hamburger-close w-inline-block ${currentPath === '/teams' ? 'w--current' : ''}`} onClick={() => setIsMenuOpen(false)} title="Teams">
            <div>Teams</div>
          </Link>
          <Link to="/pricing" className={`overlay-menu-link is--hamburger-close w-inline-block ${currentPath === '/pricing' ? 'w--current' : ''}`} onClick={() => setIsMenuOpen(false)} title="Pricing">
            <div>Pricing</div>
          </Link>
          <Link to="/faq" className={`overlay-menu-link is--hamburger-close w-inline-block ${currentPath === '/faq' ? 'w--current' : ''}`} onClick={() => setIsMenuOpen(false)} title="FAQ">
            <div>FAQ</div>
          </Link>
        </div>
        <div className="is--hamburger-open"></div>
        <div className="overlay-buttons">
          <a href={`${process.env.REACT_APP_ADMIN_URL}/login`} target="_blank" className="nav-button is--indigo is--overlay w-inline-block">
            <div>Sign in</div>
          </a>
          <a href="#pricing" target="_blank" className="nav-button is--indigo-light w-inline-block">
            <div>Sign Up</div>
          </a>
        </div>
      </div>
      <div className="w-nav-overlay" data-wf-ignore="" id="w-nav-overlay-0"></div>
    </div>
  );
};

export default Header; 